import { Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { FC } from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  line: {
    flex: 1,
  },
  text: {
    padding: theme.spacing(0, 2),
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
}));

const OrDivider: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Divider className={classes.line} />
      <Typography variant="caption" className={classes.text}>
        {'or'}
      </Typography>
      <Divider className={classes.line} />
    </div>
  );
};

export default OrDivider;
